import type { TFunction } from "i18next";
import { format, isToday, isYesterday } from "date-fns";
import type { LibraryItem } from "@/api/models/api-types";

export interface LibraryDateGroup {
  key: string;
  label: string;
  items: LibraryItem[];
}

/** Öğeleri gün bazında "Bugün / Dün / tarih" gruplarına ayırır; sıra korunur. */
export const groupItemsByDate = (
  items: LibraryItem[],
  t: TFunction,
  language: string
): LibraryDateGroup[] => {
  const dateFormatter = new Intl.DateTimeFormat(language, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const result: LibraryDateGroup[] = [];
  const byKey = new Map<string, LibraryDateGroup>();

  for (const item of items) {
    const createdAt = new Date(item.createdAt);
    const key = format(createdAt, "yyyy-MM-dd");
    let group = byKey.get(key);
    if (!group) {
      const label = isToday(createdAt)
        ? t("library.groups.today")
        : isYesterday(createdAt)
          ? t("library.groups.yesterday")
          : dateFormatter.format(createdAt);
      group = { key, label, items: [] };
      byKey.set(key, group);
      result.push(group);
    }
    group.items.push(item);
  }
  return result;
};
